<!-- 说明：目前这个组件配合 Carsousel 实现火酷项目的壁纸预览功能 -->
<!-- TODO 解决 ImageSlider 加载白屏的问题 => 采用预加载的方式解决 -->
<template>
    <div @click="preview" v-if="isPreviewable_">
        <el-tooltip class="item" effect="dark" content="手机壁纸预览" placement="bottom" :manual="true" :value="showTooltip">
            <i class="iconfont icon-sy-iphone" style="font-size: 20px"></i>
        </el-tooltip>
        <!-- @deprecated below，因为 Entity 组件使用了 flex-wrap 属性，使得 Carousel 和 PhoneInforboard 天然上下隔离开了，导致下面
        的 wallpaper 的 position fixed 属性失效。而如果把 wallpaper 放到 Entity 之外那么就不会受此影响，因此无奈，只好创建了一个 Global
        WallpaperPreviewerImage 组件，然后将其放置到 app 元素下，这样才解决了这个问题
        <div class="wallpaper" v-if="showWallpaper" :style="`margin-left: ${marginLeft}px`">
            <img class="wallpaper-img" :src="pic" />
        </div>
        -->
    </div>
</template>

<script>
    import Vue from 'vue';
    import {
        GlobalLoading,
        isHybridAgent,
        isH5PhoneAgent,
        isHtml5PlusSupported,
        getMaxScreenHeight,
        getMaxScreenWidth, getWallpaperPreviewerImageComp, isWebAgent, ShowEntityMode
    } from "../../utils";

    export default {
        name: "WallpaperPreviewer",
        data(){
            return {
                isPreviewable_: false,  // 控制手机壁纸预览按钮的展示
                showTooltip: false, // 控制提示状态的显示
                pic: null,
                size: null,
                shortcode: null,
                showTooltipDelay: 1000,
                hideTooltipAfter: 2600,
                isPopupMode: false,  // 解决 HCF380 popup entity 与 Entity 状态重复提示的问题，如果当前是 popup Entity 那么只有它提示 tooltips
                showWallpaper: false,
            }
        },
        created(){
            console.log('WallpaperPreviewer created callback')
            this.isPopupMode = this.$store.getters.getShowEntityMode() === ShowEntityMode.PopupPageMode ? true: false;
            this.$EventBus.$on('caroshowing', (data) => {
                console.log(`WallpaperPreviewer created, caroshowing event caught with data ${JSON.stringify(data, null, 4)} attached`);
                this.reset();
                this.isPreviewable_ = this.isPreviewable(data.slot, data.size) && !isWebAgent();
                if(this.isPreviewable_){
                    let shortcode = data.shortcode;
                    this.pic = data.slot.pic;
                    this.size = data.size;
                    // HCF-379 预览提示只需要全局提示三次即可，多了用户也会觉得烦。注意目前是在当前应用有效，重启后又会提示
                    // HCF-380 解决 popup entity 与 Entity 状态重复提示的问题，如果当前是 popup Entity 那么只有它提示 tooltips
                    if(this.$store.getters.isWallpaperTootipShowable(shortcode) && this.checkPopupMode()) {
                        this.$store.commit("incWallpaperCurrentPreviews")
                        // tooltip show and close after 3 seconds
                        setTimeout(() => {
                            this.showTooltip = true;
                            this.$store.commit('setWallpaperPreviewShortcode', shortcode);
                            setTimeout(() => {
                                this.showTooltip = false;
                            }, this.hideTooltipAfter);
                        }, this.showTooltipDelay);
                    }
                }
            });
        },

        beforeDestroy() {
            console.log('WallpaperPreviewer before destroy callback')
            this.$EventBus.$off('caroshowing');
            console.log('caroshowing event get unbinded');
        },

        methods: {
            reset(){
                this.size = null;
                this.pic = null;
            },

            /**
             * HCF-380：因为有弹出 popup Entity 的情况，因此，popup entity 的 Carsousel 会 caroshowing 事件同时分发给底层的 Entity 和 popup
             * Entity 两个组件。那么如何避免这种情况呢？通过 popup mode 来判断，逻辑如下，
             */
            checkPopupMode(){
                if ( this.$store.getters.getShowEntityMode() === ShowEntityMode.PopupPageMode ){
                    // 如果是 popup mode 且该 Entity 是 popped up 模式，才能显示 tooltips，否则不能显示。
                    if(this.isPopupMode){
                        return true;
                    }else{
                        return false;
                    }
                }
                // 如果不是 popup mode，那么直接返回 true
                return true;
            },

            /**
             * 视频不能预览，如果是图片，经历了如下的版本实现
             * v1: 图片的高度大于等于宽度才可以预览
             * v2: 只要是图片就可以预览
             * @param {Object} slot, entity slot
             * @param {Object} size
             * @return {boolean}
             */
            isPreviewable(slot, size){
                if(slot.video)
                    return false; // 视频资源 no
                else{ // 图片资源
                    // let width = size.width;
                    // let height = size.height;
                    // return height >= width;
                    return true;
                }
            },

            preview(){
                console.log('try to preview ...');
                if(isHybridAgent()){
                    this.preview0();
                }else if(isH5PhoneAgent()){
                    this.preview1();
                }
            },

            /**
             * Hybrib app preview - 使用 h5plus 原生的方式实现。实现已经很完美了，但是有两个弊端，
             * 1. 就是加载图片的时候的等待基本上不能自定义，一个白屏 + Spinner 用户体验很不好。
             * 2. h5plus 是使用原生组件通过 image url 加载图片，它不能使用浏览器缓存，因此还要额外加载一次。这个问题考虑将来统一通过 storage 的方式解决。
             */
            preview0(){
                // 高度说明（深入理解高度，获取屏幕、webview、软键盘高度 https://ask.dcloud.net.cn/article/205）
                // plus.screen.height 物理高度
                // plus.display.resolutionHeight 可显示区域的高度，但不包含状态栏的高度
                // plus.navigator.getStatusbarHeight()，这个api专门获取状态栏高度
                // screen.height = plus.display.resolutionHeight + plus.navigator.getStatusbarHeight()
                console.log(`screen physical height: ${plus.screen.height},
                        the display resolution height: ${plus.display.resolutionHeight},
                        status bar height: ${plus.navigator.getStatusbarHeight()},
                        screen height ${screen.height}`)
                let screenHeight = screen.height + 'px';  // 实际可用的展示高度
                // 其实 ImageSlider 就是通过 plus.nativeObj.View 原生控件生成的，因此 View 拥有的 API 那么 ImageSlider 也都拥有
                var view = new plus.nativeObj.ImageSlider('wallpaper-previewer', {
                    fullscreen: false, /* 这个是 ImageSlider 默认图片不会 full screen 显示，如果为 true 则允许用户点击屏幕 fullscreen 展示，我这里不需要 */
                    top: '0px',
                    left: '0px',
                    width: '100%',
                    height: '100%',
                    backgroundColor:'#909399',  // ImageSlider 加载网络图片是一个白屏 + spinner，看起来很不舒服，用一个深色替换。
                    // opacity: 0.2, // 未生效
                    images: [{ src: this.pic, height: screenHeight, align: 'center', verticalAlign: 'top' }]
                });
                // 应用如何全屏展示 http://ask.dcloud.net.cn/article/32（相关文章：状态栏大全-沉侵式、变色及全屏的区别 https://ask.dcloud.net.cn/article/1150）
                plus.navigator.setFullscreen(true);   // 隐藏状态栏（电量、信号...）
                // 直接显示
                view.show();
                // 监听用户的 touch 事件，关闭预览。备注：ios 上可以识别 touchend 事件，但是 Android 上不行，因此使用 click 事件。
                view.addEventListener('click', ()=>{
                    // 给个延时关闭
                    setTimeout(()=>{
                        plus.navigator.setFullscreen(false);
                        console.log('touchend event');
                        view.close();
                        view = null;
                    }, 300);
                })
            },

            /**
             * H5 preview
             * 曾经想过使用 H5 preview 的方式统一 hybrid 和 H5 手机壁纸的展示，但是 H5 差最后一步，通过他所展示的大图不能覆盖手机顶部状态，
             * 试图通过 top、margin-top 均失败了，只有拖动可以拖上去。看来，H5 的 css 作用范围不能超过状态栏？
             */
            preview1(){
                let w = getWallpaperPreviewerImageComp();
                w.zIndex = 3000;
                w.pic = this.pic;
                w.size = this.size;
                w.display();
            }
        }
    }
</script>

<style scoped>

    /* 作用到 mobile screen 禁用所有的 el-tooltip 弹出窗口 */
    @media (max-width: 735px) {
        /* 禁用 element-ui tooltip 的弹出窗口；目前主要是作用于手机端用户评论界面，弹出窗口影响 UE */
        /deep/ .el-tooltip__popper {
            /*display: inline-block !important;*/
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/commons/WallpaperPreviewer.vue